import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-doc-loader',
  standalone: true,
  imports: [],
  templateUrl: './doc-loader.component.html',
  styleUrl: './doc-loader.component.scss',
})
export class DocLoaderComponent {
  @Input() fileType: string = '';
}
